import { JabatanDocument } from '~/apollo/gql/graphql'
import type { Option } from '~/types/form'

export const useSearchJabatan = () => {
  const { result, loading, load, refetch } = useLazyQuery(JabatanDocument, { limit: 100 })

  const jabatanOptions: ComputedRef<Option<string>[]> = computed(() => {
    if (!result.value) return []

    return result.value.jabatan.map(jabatan => ({
      label: jabatan.name,
      value: jabatan.kode
    }))
  })

  const search = async (search: string) => {
    if (search === '') return []

    const loadedData = await load(null, { search, limit: 100 })
    if (!loadedData) {
      await refetch({ search, limit: 100 })
    }

    return jabatanOptions.value
  }

  return { loading, search }
}
